import type { ReactNode } from "react";

import { MobileSectionTabsProvider } from "./context/sectionTabs/MobileSectionTabsProvider";
import { MobileLayoutShellInner } from "./MobileLayoutShellInner";

export interface MobileLayoutShellProps {
  children: ReactNode;
}

/**
 * Mobile layout shell that replaces StandardLayoutV2 on mobile viewports
 * when the `circle_v4_mobileshell_enabled` feature flag is active.
 *
 * MobileSectionTabsProvider wraps MobileShell.Root so everything inside -
 * MobileShellInner and its descendants - can read/write page-specific
 * chrome overrides (tabs, title, etc.) via one of the
 * per-concern hooks it backs (`useMobileTabsOverride`,
 * `useMobileTitleOverride`, `useMobileChromeVisibility`,
 * etc. - see `MobileSectionTabsProvider`'s own doc comment for the full
 * list and why each concern gets its own context). Filters have no override
 * mechanism - they render inline as page content on every platform, see
 * `Mobile/docs/settings-tabs-override.md`.
 */
export const MobileLayoutShell = ({ children }: MobileLayoutShellProps) => (
  <MobileSectionTabsProvider>
    <MobileLayoutShellInner>{children}</MobileLayoutShellInner>
  </MobileSectionTabsProvider>
);
